import CommentInputComponent from'./CommentInput.component'

export default CommentInputComponent